import { Component, Input } from '@angular/core';
import { TrackingTimelineResponse } from '../../../model/trackingTimelineResponse.model';
import {TranslateService} from '@ngx-translate/core';	

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
	 panelOpenState = false;

	@Input() trackingResponse: TrackingTimelineResponse;
	constructor(public translate: TranslateService) {
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('fr');

    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en|fr/) ? browserLang : 'fr');
  }
  ngOnInit() {}
}
